export type InsetTextProps = {
  content?: string | React.ReactNode;
};

export const InsetText = ({ content, ...props }: InsetTextProps) => {
  return (
    <p
      className="text-bodyLg text-text-body border-l-sm pl-inset max-w-form border-current py-1 font-bold"
      {...props}
    >
      {content}
    </p>
  );
};

InsetText.displayName = 'InsetText';
